import Types from "../../constants/Types.js";
export default {
  name: 'components',
  objectType: Types.firmwareApplication,
  valueType: 'object',
  get: (data, cxt) => {
    return data?.components;
  },
  set: (data, value, cxt) => {
    return {
      ...data,
      components: value
    };
  },
  canSet: () => true,
  getPatch: (data, value, cxt) => {
    return {
      path: 'components',
      value
    };
  },
  displayName: 'Components',
  source: {
    type: Types.apiName,
    targetType: Types.firmwareComponent,
    editable: false,
    creatable: true,
    createOptions: {
      editor: 'firmwareComponentsSelector',
      editorProps: {
        toItemValue: item => {
          return item?.id ? {
            id: item?.id
          } : null;
        }
      }
    }
  }
};